<template lang='pug'>
  #navMenu.c-nav.flexD.col-24.justifySpaceBetween.alignItemsCenter(:class="{'ieNav': Common.IEVersion() != -1}")
    .c-nav__logo.cursorPointer(@click="routeTo('homepage')")
      img.block.col-24(:src="img.logo" alt="")

    .c-nav__mobile.alignItemsCenter
      .c-nav__mobile--btn.flex.alignItemsCenter.cursorPointer(@click='goBack()')
        i.fa.fa-angle-left(style="font-size:28px")
      .c-nav__mobile--logo.cursorPointer(@click="routeTo('homepage')")
        img(:src="img.logo" alt="")

    .c-nav__right.flexD
      .c-nav__language.cursorPointer.relative(@click="stopPropagation($event);toggleLanguageChild()")
        p.relative
          | {{ defaultLanguage }}
          i.absolute(:class="languageActive == true ? 'fa fa-angle-up' : 'fa fa-angle-down'")
        .c-nav__language--select.absolute(:class="{'is-active': languageActive == true}")
          p(v-for="(item, index) in languageList" :key="index" :class="{'is-active': defaultLanguage == item.name}" @click='stopPropagation($event); lang = item.value') {{ item.name }}

</template>

<script>
  export default {
    name: 'navMenu',
    data(){
      return{
        img:{
          logo: require('@/assets/img/logo_main.png'),
        },
        languageList: [
          { name: "中文", value: 'zh_cn'},
          // { name: "English", value: 'en_us'},
          // { name: "Deutsch", value: 'de_de'},
        ],
        languageDefault: localStorage.getItem('lang') || 'zh_cn',
        languageActive: false,
      }
    },
    computed: {
      lang: {
        get () {
          return this.$i18n.locale
        },
        set (v) {
          this.languageActive = false
          if (v != this.languageDefault) {
            this.$i18n.locale = v
            this.languageDefault = v
            localStorage.lang = v
            window.location.reload()
          }
        },
      },
      routeName: function() {
        return function(url){
          if (url == '/' + this.$route.name) {
            return true
          }
          return false
        }
      },
      defaultLanguage(){
        let name
        for (var i = 0; i < this.languageList.length; i++) {
          if (this.languageList[i].value == this.languageDefault) {
            name = this.languageList[i].name
          }
        }
        return name
      },
    },
    methods:{
      goBack() {
        this.$router.go(-1)
      },
      closeLanguageChild(){
        this.languageActive = false
      },
      toggleLanguageChild(){
        this.languageActive = !this.languageActive
      },
      routeTo(url){
        this.$router.push({
          name: url
        })
      },
      stopPropagation(e){
        if (e.stopPropagation) {
          e.stopPropagation();
        } else {
          e.cancelBubble = true;
        }
      },
    },
    created(){}
  }
</script>
